export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        if (x == 0) {
          $(this).replaceWith(
            `<h2 class="main-title" aria-label="${data.items[x].Title}"><span class="span-title">${data.items[x].Title}</span></h2>`,
          );
        }
        $(this).replaceWith(
          `<div class="hotBtn"><span class="span-btn">${data.items[x].Title}</span></div>`,
        );
      });
      $('.hotBtn').wrapAll('<div class="btn-groups"></div>');
      if (data.items.length == 0) {
        $(`#${widgetName}`).remove();
      }
    },

    maxItemsVisible: 5,
    itemsPerPanel: 5,
    scriptPath: widgetOpts.scriptPath,
  });
}
